import request from '@/utils/request'

// 查询企业生产装置列表
export function listStorageTankZone(query) {
  return request({
    url: 'admin/data/storageTankZone/list',
    method: 'post',
    data: query
  })
}

// 查询企业生产装置详细
export function getStorageTankZone(id) {
  return request({
    url: 'admin/data/storageTankZone/info/' + id,
    method: 'get'
  })
}

// 新增/修改企业生产装置
export function addStorageTankZone(data) {
  return request({
    url: 'admin/data/storageTankZone/saveOrUpdate',
    method: 'post',
    data: data
  })
}


// 删除企业生产装置
export function delStorageTankZone(data) {
  return request({
    url: 'admin/data/storageTankZone/delete',
    method: 'post',
    data
  })
}
